import React from 'react'
import PropTypes from 'prop-types'

import Avatar from 'material-ui/Avatar'

import WorkerDay from './WorkerDay'
import './WeekView.css'

export default class WorkerRow extends React.Component {

  static propTypes = {
    worker: PropTypes.object.isRequired,
    dateStr: PropTypes.string.isRequired,
    days: PropTypes.array.isRequired,
    teamId: PropTypes.string
  }

  renderWorkerDays() {
    const result = []
    for (const key in this.props.days) {
      if (this.props.days.hasOwnProperty(key)) {
        const day = this.props.days[key]
        result.push(
          <WorkerDay
            key={key}
            dateStr={day.key}
            isToday={day.isToday}
            worker={this.props.worker} />
        )
      }
    }
    return result
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.avatar}>
            <div>
              <Avatar
                size={33}
                backgroundColor={this.props.worker.color}>
                { this.props.worker.displayName.substring(0, 1) }
              </Avatar>
            </div>
            <span
              style={styles.name}>
              { this.props.worker.displayName }
            </span>
          </div>
        </div>
        { this.renderWorkerDays() }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    margin: 0
  },
  content: {
    flex: 1,
    textAlign: 'left',
    borderRight: '#e0e0e0 1px solid',
    borderBottom: '#e0e0e0 1px solid',
    overflow: 'hidden'
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 6,
    marginTop: 8
  },
  name: {
    marginLeft: 8,
    marginTop: 4,
    fontSize: 13,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.7)'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/week/WorkerRow.js